module.exports = __webpack_public_path__ + "img/深色地图.9ea4e860.png";